module.exports = __webpack_public_path__ + "static/img/login.ce947ea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.gif
// module id = dd9V
// module chunks = 1